import { PERMISSIONS_VIEWS, USER_ROLES } from "config/userPermissions";
import AcadReinforceListView from "../components/AcadReinforceListView/AcadReinforceListView";
import ManualLoadingForm from "../components/FormCreateAcadReinforce/ManualLoadingForm/ManualLoadingForm";
import MassiveLoadingForm from "../components/FormCreateAcadReinforce/MassiveLoadingForm/MassiveLoadingForm";
import AcadReinforceAttendance from "../components/AcadReinforceAttendance/AcadReinforceAttendance";
import AcadReinforceDetailView from "../components/AcadReinforceDetailView/AcadReinforceDetailView";

const { REF_ACAD } = PERMISSIONS_VIEWS;

export const ACAD_REINFORCE_MODULES = [
    { 
        id: REF_ACAD.LISTADO_REF_ACAD, 
        path: "", 
        View: AcadReinforceListView
    },
    {
        id: REF_ACAD.CARGA_MANUAL, 
        path: "carga-manual/*", 
        View: ManualLoadingForm
    },
    { 
        id: REF_ACAD.CARGA_MASIVA, 
        path: "carga-masiva", 
        View: MassiveLoadingForm
    },
    { 
        id: REF_ACAD.ASISTENCIA, 
        path: "asistencia", 
        View: AcadReinforceAttendance 
    }
];
export const ACAD_REINFORCE_EXTRA_MODULES = [
    {
        id: "REF_ACAD_DETALLE",
        role: [
            USER_ROLES.REF_ACAD_TUTOR,
            USER_ROLES.EVENTOS_DOCENTE
        ],
        path: "detalle",
        View: AcadReinforceDetailView
    }
];